import 'css-chunksrc/client/common/dragAndDrop/draggable/styles.scss';export default {
  "grabbingCursor": "_grabbingCursor_147sv_1"
};